<script lang="ts" setup>
import type { ComponentElementsLinkWrapper } from '@autobid/strapi-integration/graphql/graphql'
import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'

interface Props {
  data: ComponentElementsLinkWrapper
}

defineProps<Props>()

const { isAuthed, signIn } = useAutobidAuth()
</script>

<template>
  <layout-header-partials-link
    v-if="!isAuthed"
    class="items-center"
    as="button"
    @click="signIn"
  >
    {{ data.text }}

    <template v-if="data.icon" #icon>
      <CommonIcon :name="data.icon" class="h-9 w-9" />
    </template>
  </layout-header-partials-link>
</template>
